import { useState } from "react";
import { Button, Card, Col, Row, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import ImageDeleteModal from "../ImageDeleteModal/ImageDeleteModal";
import ImageUploadModal from "../ImageUploadModal/ImageUploadModal";

interface ImageItem {
  url: string;
  nombre: string;
}

interface ImageGalleryProps {
  idActividad: number;
  images: ImageItem[];
  tipo: string;
  onImageDeleted?: () => void;
}

const ImageGallery = ({
  idActividad,
  images,
  tipo,
  onImageDeleted,
}: ImageGalleryProps) => {
  const [showModal, setShowModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [imageErrors, setImageErrors] = useState<Set<string>>(new Set());

  const handleDeleteClick = (imageName: string) => {
    setSelectedImage(imageName);
    setShowModal(true);
  };

  const handleSuccess = () => {
    onImageDeleted?.();
  };

  const handleImageError = (imageName: string) => {
    setImageErrors(prev => new Set(prev).add(imageName));
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          {images.length === 0 ? (
            <p className="text-muted mb-0">No hay imágenes disponibles</p>
          ) : (
            <p className="text-muted mb-0">{images.length} imagen(es)</p>
          )}
        </div>
        <Button variant="primary" size="sm" onClick={() => setShowUploadModal(true)}>
          <FontAwesomeIcon icon={faPlus} /> Subir imágenes
        </Button>
      </div>

      {imageErrors.size > 0 && (
        <Alert variant="warning">
          Algunas imágenes no se pueden cargar. Verifica que las carpetas sean accesibles públicamente en el servidor.
        </Alert>
      )}
      
      <Row>
        {images.map((image, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-3">
            <Card>
              {!imageErrors.has(image.nombre) ? (
                <Card.Img 
                  variant="top" 
                  src={image.url} 
                  alt={image.nombre}
                  onError={() => handleImageError(image.nombre)}
                  style={{ height: '200px', objectFit: 'cover' }}
                />
              ) : (
                <div style={{ height: '200px', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span className="text-muted">Imagen no disponible</span>
                </div>
              )}
              <Card.Body>
                <Card.Text className="text-truncate" title={image.nombre}>{image.nombre}</Card.Text>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDeleteClick(image.nombre)}
                >
                  <FontAwesomeIcon icon={faTrash} /> Eliminar
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <ImageDeleteModal
        show={showModal}
        onHide={() => setShowModal(false)}
        idActividad={idActividad}
        nombreArchivo={selectedImage}
        onSuccess={handleSuccess}
      />

      <ImageUploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        idActividad={idActividad}
        tipo={tipo}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default ImageGallery;
